import axios from 'axios'
import DurationInterface from '@/models/DurationInterface'

export default class DurationService {
  private baseUrl = '/api/v1/durations'

  public getAll() {
    return axios.get(`${this.baseUrl}/`)
  }

  public getById(id: number) {
    return axios.get(`${this.baseUrl}/${id}`)
  }

  public create(duration: Partial<DurationInterface>) {
    return axios.post(`${this.baseUrl}/`, duration)
  }

  public update(id: number, duration: Partial<DurationInterface>) {
    return axios.put(`${this.baseUrl}/${id}`, duration)
  }

  public delete(id: number) {
    return axios.delete(`${this.baseUrl}/${id}`)
  }
}
